const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInternet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9563 44.6794C12.937 40.1132 12.2816 34.1348 14.7442 28.7999C17.8189 22.1421 24.8045 18.5348 31.7105 19.4433",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6496 38.6562C45.4062 39.955 44.999 41.2466 44.4183 42.502C40.6351 50.6972 30.9243 54.2707 22.7291 50.4876C21.3026 49.8297 20.0183 48.9912 18.8857 48.0129",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2432 36.1221L18.6817 35.4595C19.0552 35.4137 19.4335 35.5221 19.7251 35.7607L22.2432 37.8089C22.4359 37.9655 22.5829 38.1727 22.6697 38.4065L23.7685 41.3896C24.0745 42.2209 25.0721 42.5559 25.8191 42.0788L27.1853 41.2041C27.3853 41.0764 27.6167 41.0017 27.8552 40.9872L31.0865 40.8017C31.5974 40.7727 32.0528 40.4643 32.2673 39.9993C32.5612 39.3655 33.2793 39.0474 33.9444 39.2571L36.1926 39.9679C36.6649 40.1173 37.0215 40.5077 37.1299 40.992L37.9877 44.8739C38.0793 45.2932 37.9733 45.7318 37.6986 46.0619L37.3564 46.4715C36.9588 46.9462 36.2962 47.1029 35.7299 46.8523L33.3685 45.8089C32.8215 45.5679 32.1805 45.7029 31.7805 46.1462L29.9588 48.1559C29.5805 48.5727 28.9853 48.7197 28.4552 48.527L23.7902 46.8258C23.5564 46.739 23.301 46.7197 23.0552 46.7655L22.3998 46.8908C21.7251 47.0185 21.06 46.6354 20.8311 45.9872L20.3299 44.5607C20.0721 43.8282 19.2649 43.4499 18.5371 43.7197L15.9588 44.6788",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.257 29.3396L18.8185 30.5445C19.0185 30.971 19.4281 31.2625 19.898 31.3059L21.763 31.4818C22.1052 31.5131 22.4209 31.677 22.645 31.9348L23.6859 33.1396C24.3173 33.8698 25.4932 33.7059 25.898 32.8288L26.5462 31.424C26.6763 31.1421 26.7028 30.824 26.6233 30.5228L25.8811 27.7541C25.6835 27.0192 24.9124 26.5999 24.1871 26.8336L23.351 27.1035C22.8835 27.2553 22.3703 27.1348 22.0185 26.7927C21.5775 26.3662 20.9052 26.2963 20.3847 26.6216L18.751 27.6505C18.1871 28.0095 17.9751 28.7324 18.257 29.3396Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2768 35.5611L41.6792 35.019C40.8551 34.9105 40.1177 34.4503 39.6575 33.7563L38.5153 32.0358C38.0262 31.3009 37.2262 30.8286 36.3442 30.7587L35.8358 30.7178C34.7298 30.6286 33.7732 29.9129 33.3756 28.8768L32.4527 26.4696C32.1491 25.6744 32.2117 24.7852 32.6238 24.0407L34.4093 20.9395C34.4093 20.9443 44.79 23.5901 45.2768 35.5611Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8265 5.32048C52.8265 6.27711 52.4217 7.13735 51.7759 7.74217C51.1831 8.29879 50.3855 8.63855 49.506 8.63855C48.6289 8.63855 47.8313 8.29879 47.2361 7.74217C46.5904 7.13735 46.1855 6.2747 46.1855 5.32048C46.1855 3.48675 47.6723 2 49.506 2C51.3398 2 52.8265 3.48675 52.8265 5.32048Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1859 15.547H54.8871V10.494C54.8871 8.97351 53.6533 7.74219 52.1353 7.74219H51.7738C51.181 8.29881 50.3834 8.63857 49.5039 8.63857C48.6268 8.63857 47.8292 8.29881 47.234 7.74219H46.8726C45.3521 7.74219 44.1208 8.97592 44.1208 10.494V15.547L39.2461 19.441",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88184 5.32048C2.88184 6.27711 3.28666 7.13735 3.93244 7.74217C4.52521 8.29879 5.3228 8.63855 6.20232 8.63855C7.07943 8.63855 7.87702 8.29879 8.4722 7.74217C9.11798 7.13735 9.5228 6.2747 9.5228 5.32048C9.52039 3.48675 8.03364 2 6.19991 2C4.36617 2 2.88184 3.48675 2.88184 5.32048Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70361 15.547H1V10.494C1 8.97351 2.23373 7.74219 3.75181 7.74219H4.11325C4.70602 8.29881 5.50361 8.63857 6.38313 8.63857C7.26024 8.63857 8.05783 8.29881 8.65301 7.74219H9.01446C10.5349 7.74219 11.7663 8.97592 11.7663 10.494V15.547L16.641 19.441",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0625 48.6545C3.0625 49.6111 3.46732 50.4713 4.1131 51.0762C4.70587 51.6328 5.50346 51.9725 6.38298 51.9725C7.26009 51.9725 8.05768 51.6328 8.65286 51.0762C9.29864 50.4713 9.70346 49.6087 9.70346 48.6545C9.70346 46.8207 8.21672 45.334 6.38298 45.334C4.54925 45.334 3.0625 46.8207 3.0625 48.6545Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7012 58.881H1V53.828C1 52.3075 2.23373 51.0762 3.75181 51.0762H4.11325C4.70602 51.6328 5.50361 51.9726 6.38313 51.9726C7.26024 51.9726 8.05783 51.6328 8.65301 51.0762H9.01446C10.5349 51.0762 11.7663 52.3099 11.7663 53.828V58.881H11.7349",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 51.4994L14.747 48.3125",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.973 48.6545C56.973 49.6111 56.5682 50.4713 55.9224 51.0762C55.3296 51.6328 54.532 51.9725 53.6525 51.9725C52.7754 51.9725 51.9778 51.6328 51.3826 51.0762C50.7369 50.4713 50.332 49.6087 50.332 48.6545C50.332 46.8207 51.8188 45.334 53.6525 45.334C55.4862 45.334 56.973 46.8207 56.973 48.6545Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3346 58.881H59.0358V53.828C59.0358 52.3075 57.8021 51.0762 56.284 51.0762H55.9225C55.3298 51.6328 54.5322 51.9726 53.6527 51.9726C52.7756 51.9726 51.978 51.6328 51.3828 51.0762H51.0213C49.5009 51.0762 48.2695 52.3099 48.2695 53.828V58.881H48.3009",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6288 52.4691L44.2891 48.3125",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInternet);
export default __webpack_public_path__ + "static/media/icon-internet.52d83e3240a87f649b6e1a6e2e508fa4.svg";
export { ForwardRef as ReactComponent };